import React from 'react';

function DriverStats({ totalDeliveries, rating, activeOrders }) {
  const safeRating = typeof rating === 'number' && !isNaN(rating) && isFinite(rating)
    ? rating
    : 5.0;

  return (
    <div className="stats-grid">
      <div className="stat-card">
        <div className="stat-icon">📦</div>
        <div className="stat-info">
          <p className="stat-value">{totalDeliveries}</p>
          <p className="stat-label">Entregas</p>
        </div>
      </div>
      <div className="stat-card">
        <div className="stat-icon">⭐</div>
        <div className="stat-info">
          <p className="stat-value">{safeRating.toFixed(1)}</p>
          <p className="stat-label">Calificación</p>
        </div>
      </div>
      <div className="stat-card">
        <div className="stat-icon">🚚</div>
        <div className="stat-info">
          <p className="stat-value">{activeOrders}</p>
          <p className="stat-label">Activos</p>
        </div>
      </div>
    </div>
  );
}

export default DriverStats;
